import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../../styles/admin/AdminLayout.css';

const AdminSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { label: '관리자 홈', path: '/admin' },
    { label: '광고주 관리', path: '/admin/advertiser' },
    { label: '인플루언서 관리', path: '/admin/influencer' },
    { label: '프로젝트 관리', path: '/admin/project' },
    { label: '포인트 관리', path: '/admin/point' },
    { label: '매출 관리', path: '/admin/money' },
    { label: '공지사항 작성', path: '/admin/create-notice' },
  ];

  const isActive = (path) => {
    if (path === '/admin') {
      return location.pathname === '/admin';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <aside className="admin-sidebar">
      <div className="admin-sidebar__logo" onClick={() => navigate('/admin')}>
        ADMIN
      </div>
      <nav className="admin-sidebar__nav">
        {menuItems.map((item) => (
          <button
            key={item.path}
            className={`admin-sidebar__menu-item ${isActive(item.path) ? 'admin-sidebar__menu-item--active' : ''}`}
            onClick={() => navigate(item.path)}
          >
            {item.label}
          </button>
        ))}
      </nav>
    </aside>
  );
};

export default AdminSidebar;

